export default function copyProps(inProps, ignore = []) {
  // copys props into a new object
  // ignore is an array of props you don't want copied
  // ignore VSTComponent necessary props
  ignore.push('primary');
  ignore.push('accent');
  ignore.push('theme');
  ignore.push('themeMap');

  const props = {};
  let key;
  for (key in inProps) {
    if (inProps.hasOwnProperty(key) && !ignore.includes(key)) {
      props[key] = inProps[key];
    }
  }
  return props;
}
